/*eslint-disable*/ export const messages = {
    "Go to the first page": "Vai alla prima pagina",
    "Go to the last page": "Vai alla pagina finale",
    "Pagination, showing {from} through {to} of {total} entities": [
        "Paginazione, visualizzazione da ",
        ["from"],
        " a ",
        ["to"],
        " di ",
        ["total"],
        " entità",
    ],
    "Show next {entitiesPerPage} entities": ["Visualizza ", ["entitiesPerPage"], " entità successive"],
    "Show previous {entitiesPerPage} entities": ["Visualizza ", ["entitiesPerPage"], " entità precedenti"],
    "{from} through {to} of {total}": ["Da ", ["from"], " a ", ["to"], " di ", ["total"]],
    "{from}-{to} of {total}": [["from"], "-", ["to"], " di ", ["total"]],
};
